module.exports = __webpack_public_path__ + "media/images/carta-final-3c94a611ab8c089d7421bd6b5ec707a9.svg";